import {
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography
} from '@material-ui/core'
import {
  ERROR_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS,
  WARNING_COLORS
} from 'asterX-UI'
import { ArrowRightIcon } from 'asterX-UI/Icons'
import { useRopCardStyles } from './rop-card.styles'
import clsx from 'clsx'

export const RopCard = ({ title, value, color, icon, onClick }) => {
  const classes = useRopCardStyles()

  const valueColor = {
    red: ERROR_COLORS[600],
    green: SUCCESS_COLORS[600],
    primary: PRIMARY_COLORS[600],
    orange: WARNING_COLORS[600]
  }

  return (
    <Card>
      <CardActionArea className={classes.cardAction}>
        <CardContent className={classes.cardContent}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <div className={clsx(classes.icon, classes[color])}>{icon}</div>
            </Grid>
            <Grid item style={{ flexGrow: 1 }}>
              <Typography className={classes.cardTitle}>{title}</Typography>
              <Typography
                className={classes.cardValue}
                variant="h5"
                style={{
                  color: valueColor[color]
                }}
              >
                {value}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}
